module.exports = __webpack_public_path__ + "img/download-app-bg.2befb9b2.png";